import { countries as countriesList } from 'countries-list'
import getUnicodeFlag from 'country-flag-icons/unicode'

// Handle both CommonJS and ES module exports
const getFlagFunction = getUnicodeFlag?.default || getUnicodeFlag

export interface Country {
  code: string
  name: string
  flag: string
  emoji: string
}

// Convert countries-list data to our format
export const COUNTRIES: Country[] = Object.entries(countriesList).map(([code, countryData]) => {
  const flag = getFlagFunction(code) || '🏳️'
  return {
    code,
    name: countryData.name,
    flag,
    emoji: flag
  }
}).sort((a, b) => a.name.localeCompare(b.name))

export const getCountryByCode = (code: string): Country | undefined => {
  return COUNTRIES.find(country => country.code === code)
}

export const getCountriesByName = (search: string): Country[] => {
  const searchLower = search.toLowerCase()
  return COUNTRIES.filter(country =>
    country.name.toLowerCase().includes(searchLower) ||
    country.code.toLowerCase().includes(searchLower)
  )
}

// Popular country groups for convenience
export const EU_COUNTRIES = COUNTRIES.filter(country =>
  ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'].includes(country.code)
)

export const NORTH_AMERICA_COUNTRIES = COUNTRIES.filter(country =>
  ['US', 'CA', 'MX'].includes(country.code)
)

export const G7_COUNTRIES = COUNTRIES.filter(country =>
  ['US', 'JP', 'DE', 'GB', 'FR', 'IT', 'CA'].includes(country.code)
)